import { ActionsContext } from '../../core/actionsContext/contextFactory';
import {
  ApplicationState,
  ApplicationStatus,
  BookingStatus,
  TabTypes,
} from '../../types';
import { mockUserInfo } from '../../../__tests__/mocks/mockUserInfo';
import { mockSelectedTimezone } from '../../../__tests__/mocks/mockSelectedTimezone';
import { mockMemberAreaBookings } from '../../../__tests__/mocks/mockMemberAreaBookings';
import { mockSelectedTab } from '../../../__tests__/mocks/mockSelectedTab';
import { mockGroup } from '../../../__tests__/mocks/mockGroup';
import BookingBuilder from '../../../__tests__/mocks/mockBooking';
import { mockService } from '../../../__tests__/mocks/mockService';
import StaffBuilder from '../../../__tests__/mocks/mockStaff';
import { mockBusinessInfo } from '../../../__tests__/mocks/mockBusinessInfo';

export const createEmptyDummyState = (): ApplicationState => {
  return {
    status: ApplicationStatus.IDLE,
    selectedTab: mockSelectedTab({ type: TabTypes.UPCOMING }),
    environmentModes: {
      isEditorMode: true,
      isPreviewMode: false,
      isSiteMode: false,
    },
    businessInfo: mockBusinessInfo(),
    userInfo: mockUserInfo(),
    selectedTimezone: mockSelectedTimezone(),
    upcomingData: mockMemberAreaBookings({
      groups: [],
    }),
  };
};

export const createUpcomingDummyState = ({
  flowAPI,
}: ActionsContext): ApplicationState => {
  const { t } = flowAPI.translations;
  const staffMember = t('app.my-bookings-widget.dummy.staff-member');
  const serviceName = t('app.my-bookings-widget.dummy.service-name');
  const serviceAddress = t('app.my-bookings-widget.dummy.service-address');

  const relatedStaff = StaffBuilder().buildWithName(staffMember).build();
  const groups = [
    mockGroup({
      bookings: [
        BookingBuilder()
          .withService(mockService({ name: serviceName }))
          .withVideoConference({ link: 'wix.com' })
          .build(),
      ],
    }),
    mockGroup({
      bookings: [
        BookingBuilder()
          .withVideoConference({ link: 'wix.com' })
          .withLocationInfo(serviceAddress)
          .withStaffInfo(relatedStaff)
          .withCancelAllowed()
          .withBookAnotherAllowed()
          .withRescheduleAllowed()
          .withService(mockService({ name: `${serviceName} 1` }))
          .build({
            staffID: relatedStaff.id,
          }),
        BookingBuilder()
          .withVideoConference({ link: 'wix.com' })
          .withStaffInfo(relatedStaff)
          .withService(mockService({ name: `${serviceName} 2` }))
          .build({
            staffID: relatedStaff.id,
          }),
      ],
    }),
    mockGroup({
      bookings: [
        BookingBuilder()
          .withService(mockService({ name: serviceName }))
          .withStatus(BookingStatus.PENDING_APPROVAL)
          .build(),
      ],
    }),
    mockGroup({
      bookings: [
        BookingBuilder()
          .withService(mockService({ name: serviceName }))
          .withVideoConference({ link: 'wix.com' })
          .build(),
      ],
    }),
    mockGroup({
      bookings: [
        BookingBuilder()
          .withService(mockService({ name: serviceName }))
          .withStatus(BookingStatus.PENDING)
          .build(),
      ],
    }),
  ];

  return {
    status: ApplicationStatus.IDLE,
    selectedTab: mockSelectedTab({ type: TabTypes.UPCOMING }),
    environmentModes: {
      isEditorMode: true,
      isPreviewMode: false,
      isSiteMode: false,
    },
    businessInfo: mockBusinessInfo(),
    userInfo: mockUserInfo(),
    selectedTimezone: mockSelectedTimezone(),
    upcomingData: mockMemberAreaBookings({
      groups,
    }),
  };
};
